import React from 'react'
import { createRoot } from 'react-dom/client'
import { I18nextProvider } from 'react-i18next'
import App from './App'
import axeConfig from './axeConfig'
import i18next from './koso18n'

axeConfig()

const container = document.getElementById('root')
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!)
root.render(
  <I18nextProvider i18n={i18next}>
    <App />
  </I18nextProvider>,
)
